import { Layout } from '@/components';
import { OnboardingForm } from './_components';

const ApplicationOnboardingScreen = () => {
	return (
		<Layout>
			<OnboardingForm />
		</Layout>
	);
};

export default ApplicationOnboardingScreen;
